{
  "account-existed-dialog": {
    "buttons": {
      "cancel": "Abbrechen",
      "login": "Anmelden"
    },
    "text": {
      "title": "Es gibt bereits ein Konto mit dieser E-Mail: {{ email }} oder Telefonnummer: {{ phoneNr }}",
      "title-email-exists": "Es gibt bereits ein Konto mit dieser E-Mail: {{ email }}",
      "title-phone-exists": "Es gibt bereits ein Konto mit dieser Telefonnummer: {{ phoneNr }}",
      "hint": "Sie können sich direkt mit dieser E-Mail/Telefonnummer anmelden oder eine andere E-Mail/Telefonnummer für die Registrierung verwenden.",
      "hint-email-exists": "Sie können sich direkt mit dieser E-Mail anmelden oder eine andere E-Mail für die Registrierung verwenden.",
      "hint-phone-exists": "Sie können sich direkt mit dieser Telefonnummer anmelden oder eine andere Telefonnummer für die Registrierung verwenden."
    }
  }
}
